var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "holiday-main-root" }, [
    _c(
      "div",
      {
        staticClass: "custom-nav-block",
        style: `padding-top:${_vm.barHeight}px`,
      },
      [
        _c("van-nav-bar", {
          staticClass: "van-bar",
          attrs: { "left-arrow": "" },
          on: { "click-left": _vm.closeWeb, "click-right": _vm.handleToRule },
          scopedSlots: _vm._u([
            {
              key: "left",
              fn: function () {
                return [
                  _c("img", {
                    staticClass: "left-nav",
                    attrs: {
                      src: require("@/assets/packageAssets/common/arrow02.png"),
                      alt: "",
                    },
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "right",
              fn: function () {
                return [
                  _c("span", { staticClass: "tit-right" }, [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/rules02.png"),
                        alt: "",
                      },
                    }),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "holiday-con",
        style: { "margin-top": `-${_vm.barHeight + 46}px` },
      },
      [
        _c("div", { staticClass: "holiday-head" }, [
          _c("img", {
            staticClass: "head-img-back",
            attrs: { src: require("./images/main-bg.png") },
          }),
          _c(
            "div",
            {
              staticClass: "head-img",
              style: { "margin-top": `${_vm.barHeight + 36}px` },
            },
            [
              _c("img", {
                attrs: { src: _vm.getMatchTitle("tit-bg-", _vm.$i18n.locale) },
              }),
            ]
          ),
          _c("div", { staticClass: "deal-line" }, [
            _c("div", { staticClass: "timer" }, [
              _c("img", { attrs: { src: require("./images/clock.png") } }),
              _c("span", { staticClass: "time-num" }, [
                _c("span", [_vm._v(_vm._s(_vm.countdownResult.days))]),
                _c("i", [_vm._v(_vm._s(_vm.$t("lang.commonM.k297")))]),
              ]),
              _c("span", { staticClass: "stp" }, [_vm._v(":")]),
              _c("span", { staticClass: "time-num" }, [
                _c("span", [_vm._v(_vm._s(_vm.countdownResult.hours))]),
                _c("i", [_vm._v(_vm._s(_vm.$t("lang.commonM.k364")))]),
              ]),
              _c("span", { staticClass: "stp" }, [_vm._v(":")]),
              _c("span", { staticClass: "time-num" }, [
                _c("span", [_vm._v(_vm._s(_vm.countdownResult.minutes))]),
                _c("i", [_vm._v(_vm._s(_vm.$t("lang.commonM.k365")))]),
              ]),
              _c("span", { staticClass: "stp" }, [_vm._v(":")]),
              _c("span", { staticClass: "time-num" }, [
                _c("span", [_vm._v(_vm._s(_vm.countdownResult.seconds))]),
                _c("i", [_vm._v(_vm._s(_vm.$t("lang.commonM.k366")))]),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "main-con" }, [
          _c(
            "div",
            { staticClass: "part-block", staticStyle: { "margin-top": "0" } },
            [
              _c("div", { staticClass: "part-head" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k208")))]),
              ]),
              _c("div", { staticClass: "part-tips" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k419"))),
              ]),
              _vm.actInfo
                ? _c("div", { staticClass: "points-rank" }, [
                    _c("div", { staticClass: "pr-item" }, [
                      _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k221")))]),
                      _vm.actInfo
                        ? _c("div", [_vm._v(_vm._s(_vm.actInfo.score || 0))])
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "pr-gap" }),
                    _c(
                      "div",
                      { staticClass: "pr-item" },
                      [
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("lang.commonM.k222"))),
                        ]),
                        _vm.actInfo
                          ? [
                              _c("div", [
                                _vm._v(_vm._s(_vm.actInfo.rank || "--")),
                              ]),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
            ]
          ),
          _c("div", { staticClass: "part-block" }, [
            _c("div", { staticClass: "part-head" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k218")))]),
            ]),
            _c("div", { staticClass: "part-tips" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k420"))),
            ]),
            _c("div", { staticClass: "holiday-reward" }, [
              _c("div", { staticClass: "holiday-item" }, [
                _c("div", { staticClass: "reward-num" }, [_vm._v("No.1")]),
                _c("div", { staticClass: "reward-coins" }, [
                  _vm._v(" " + _vm._s(_vm.boardData.num1Reward) + " "),
                  _c("img", {
                    staticClass: "coins-icon",
                    attrs: { src: _vm.getMatchImg("beans") },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "holiday-item" }, [
                _c("div", { staticClass: "reward-num" }, [_vm._v("No.2")]),
                _c("div", { staticClass: "reward-coins" }, [
                  _vm._v(" " + _vm._s(_vm.boardData.num2Reward) + " "),
                  _c("img", {
                    staticClass: "coins-icon",
                    attrs: { src: _vm.getMatchImg("beans") },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "holiday-item" }, [
                _c("div", { staticClass: "reward-num" }, [_vm._v("No.3")]),
                _c("div", { staticClass: "reward-coins" }, [
                  _vm._v(" " + _vm._s(_vm.boardData.num3Reward) + " "),
                  _c("img", {
                    staticClass: "coins-icon",
                    attrs: { src: _vm.getMatchImg("beans") },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "holiday-item" }, [
                _c("div", { staticClass: "reward-num" }, [_vm._v("No.4-10")]),
                _c("div", { staticClass: "reward-coins" }, [
                  _vm._v(" " + _vm._s(_vm.boardData.num4Reward) + " "),
                  _c("img", {
                    staticClass: "coins-icon",
                    attrs: { src: _vm.getMatchImg("beans") },
                  }),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "btn-block" }, [
              _c(
                "div",
                { staticClass: "holiday-btn", on: { click: _vm.handleToRank } },
                [_vm._v(_vm._s(_vm.$t("lang.commonM.k220")))]
              ),
            ]),
          ]),
          _c("div", { staticClass: "part-block" }, [
            _c("div", { staticClass: "part-head" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k215")))]),
            ]),
            _c("div", { staticClass: "part-tips" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k421"))),
            ]),
            _vm.actInfo &&
            _vm.actInfo.milestoneStates &&
            _vm.actInfo.milestoneRewards
              ? _c("div", { staticClass: "part-percent" }, [
                  _c("div", { staticClass: "progress-box" }, [
                    _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "box-top",
                          style: {
                            opacity:
                              _vm.actInfo.milestoneStates[0] === 2 ? 0.5 : 1,
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              " " + _vm._s(_vm.actInfo.milestoneRewards[0])
                            ),
                            _c("img", {
                              attrs: { src: _vm.getMatchImg("beans") },
                            }),
                          ]),
                        ]
                      ),
                      _vm.actInfo.milestoneStates[0] === 2
                        ? _c("img", {
                            staticClass: "box",
                            attrs: { src: require("./images/box-open.png") },
                          })
                        : _vm._e(),
                      _vm.actInfo.milestoneStates[0] === 1
                        ? _c("img", {
                            staticClass: "box sharking",
                            attrs: { src: require("./images/box.png") },
                          })
                        : _vm._e(),
                      _vm.actInfo.milestoneStates[0] === 0
                        ? _c("img", {
                            staticClass: "box",
                            attrs: { src: require("./images/box.png") },
                          })
                        : _vm._e(),
                    ]),
                    _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "box-top",
                          style: {
                            opacity:
                              _vm.actInfo.milestoneStates[1] === 2 ? 0.5 : 1,
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              " " + _vm._s(_vm.actInfo.milestoneRewards[1])
                            ),
                            _c("img", {
                              attrs: { src: _vm.getMatchImg("beans") },
                            }),
                          ]),
                        ]
                      ),
                      _vm.actInfo.milestoneStates[1] === 2
                        ? _c("img", {
                            staticClass: "box",
                            attrs: { src: require("./images/box-open.png") },
                          })
                        : _vm._e(),
                      _vm.actInfo.milestoneStates[1] === 1
                        ? _c("img", {
                            staticClass: "box sharking",
                            attrs: { src: require("./images/box.png") },
                          })
                        : _vm._e(),
                      _vm.actInfo.milestoneStates[1] === 0
                        ? _c("img", {
                            staticClass: "box",
                            attrs: { src: require("./images/box.png") },
                          })
                        : _vm._e(),
                    ]),
                    _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "box-top",
                          style: {
                            opacity:
                              _vm.actInfo.milestoneStates[2] === 2 ? 0.5 : 1,
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              " " + _vm._s(_vm.actInfo.milestoneRewards[2])
                            ),
                            _c("img", {
                              attrs: { src: _vm.getMatchImg("beans") },
                            }),
                          ]),
                        ]
                      ),
                      _vm.actInfo.milestoneStates[2] === 2
                        ? _c("img", {
                            staticClass: "box",
                            attrs: { src: require("./images/box-open.png") },
                          })
                        : _vm._e(),
                      _vm.actInfo.milestoneStates[2] === 1
                        ? _c("img", {
                            staticClass: "box sharking",
                            attrs: { src: require("./images/box.png") },
                          })
                        : _vm._e(),
                      _vm.actInfo.milestoneStates[2] === 0
                        ? _c("img", {
                            staticClass: "box",
                            attrs: { src: require("./images/box.png") },
                          })
                        : _vm._e(),
                    ]),
                  ]),
                  _c("div", { staticClass: "progress-wraper" }, [
                    _c("div", { staticClass: "progress-bar" }, [
                      _c("div", {
                        staticClass: "step step0",
                        class: { on: _vm.actInfo.milestoneStates[0] > 0 },
                      }),
                      _c("div", {
                        staticClass: "step step1",
                        class: { on: _vm.actInfo.milestoneStates[1] > 0 },
                      }),
                      _c("div", {
                        staticClass: "step step5",
                        class: { on: _vm.actInfo.milestoneStates[2] > 0 },
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "progress-trace",
                          style: { width: _vm.mePosition },
                        },
                        [_c("div", { staticClass: "me" })]
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "progress-points" }, [
                    _c("div", { staticClass: "points-name" }, [
                      _vm._v(_vm._s(_vm.$t("lang.valRuFe.points")) + ":"),
                    ]),
                    _vm._m(0),
                  ]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "btn-block" }, [
              _vm.canClaim == "canClaim"
                ? _c(
                    "div",
                    {
                      staticClass: "holiday-btn",
                      on: {
                        click: function ($event) {
                          return _vm.handleClaim()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("lang.commonM.k073")))]
                  )
                : _vm._e(),
              _vm.canClaim == "canNotClaim"
                ? _c("div", { staticClass: "holiday-btn btn-disable" }, [
                    _vm._v(_vm._s(_vm.$t("lang.commonM.k073"))),
                  ])
                : _vm._e(),
              _vm.canClaim == "claimed"
                ? _c("div", { staticClass: "holiday-btn btn-disable" }, [
                    _vm._v(_vm._s(_vm.$t("lang.commonM.k074"))),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
      ]
    ),
    _vm.showReward
      ? _c("div", { staticClass: "mask" }, [
          _c("div", { staticClass: "dia-con" }, [
            _c("div", { staticClass: "reward-item" }, [
              _c("span", [_vm._v(_vm._s(_vm.reward))]),
              _c("img", { attrs: { src: _vm.getMatchImg("beans"), alt: "" } }),
            ]),
            _c("p", { staticClass: "dia-tips" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k378"))),
            ]),
            _c(
              "div",
              {
                staticClass: "rules-btn",
                on: {
                  click: function ($event) {
                    _vm.showReward = false
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("lang.ok")))]
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "points-num" }, [
      _c("div", [_vm._v("10")]),
      _c("div", [_vm._v("20")]),
      _c("div", [_vm._v("30")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }